import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Footer } from '.';

const PageNotFound: React.FC = () => {

  const navigate = useNavigate();

  return (
    <div>
      <div className='flex justify-center items-center h-screen'>
        <div className='flex flex-col gap-6 items-center w-full md:w-full lg:w-1/3 mx-6 md:mx-16 lg:mx-0 font-outfit'>
          <span className='text-2xl font-bold'>ERROR</span>
          <h1 className='text-8xl text-primary'>404</h1>
          <span className='text-2xl font-medium text-goldenDark'>Page Not Found</span>
          <span className='text-center text-md font-semibold text-textColor'>The page you are looking for might have been removed had its name change or its temporarily unavailable</span>
          <div className='mx-auto'>
            <Button name="HOME PAGE" type='first' htmlType='button' onClick={() => navigate('/')} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default PageNotFound;